var _defs, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRouletteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Roulette Icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "roulette-cut",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 57,
    height: 57
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.34,
    cy: 28.34,
    r: 16,
    fill: "none",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 28.34,
    y1: 28.34,
    x2: 42.34,
    y2: 28.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.34,
    y1: 28.34,
    x2: 38.24,
    y2: 38.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.34,
    y1: 28.34,
    x2: 28.34,
    y2: 42.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.34,
    y1: 28.34,
    x2: 18.44,
    y2: 38.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.34,
    y1: 28.34,
    x2: 14.34,
    y2: 28.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.34,
    y1: 28.34,
    x2: 18.44,
    y2: 18.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.34,
    y1: 28.34,
    x2: 28.34,
    y2: 14.34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.34,
    y1: 28.34,
    x2: 38.24,
    y2: 18.44
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 28.34,
    cy: 28.34,
    r: 2.6,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.34 6.5 L25.84 12.34 L30.84 12.34 Z",
    fill: "black"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.34,
    cy: 28.34,
    r: 28.34,
    fill: "#00ADEE",
    mask: "url(#roulette-cut)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouletteIcon);
export default __webpack_public_path__ + "static/media/roulette-icon.0278a699656c9296ead5dfea642cecad.svg";
export { ForwardRef as ReactComponent };